import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminLayout } from "./components/AdminLayout";
import { DashboardPage } from "./pages/DashboardPage";
import { ModerationQueuePage } from "./pages/ModerationQueuePage";
import { ExperiencesPage } from "./pages/ExperiencesPage";
import { CompanySuggestionsPage } from "./pages/CompanySuggestionsPage";
import { CompaniesPage } from "./pages/CompaniesPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/moderation" element={<ModerationQueuePage />} />
                  <Route path="/experiences" element={<ExperiencesPage />} />
                  <Route path="/company-suggestions" element={<CompanySuggestionsPage />} />
                  <Route path="/companies" element={<CompaniesPage />} />
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
